// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.toolbar {
  align-items: center;
  display: flex;
  justify-content: space-between;
  background: #c0def0;
  color: #19608f;
  padding-right: 24px;
}
.toolbar .tb-content-wrapper {
  align-items: center;
  background: #c0def0;
  color: #19608f;
  display: flex;
  font-size: 4rem;
  font-weight: 900;
  height: 80px;
  padding: 0 12px 0 36px;
}
.toolbar .tb-content-wrapper .divider {
  border-left: 1px solid white;
  height: 60px;
  margin: 0px 24px;
}
.toolbar .tb-content-wrapper .toolbar-link-home {
  color: #19608f;
  font-size: 2rem;
  font-weight: 700;
  text-decoration: none;
}
.toolbar .tb-content-wrapper span {
  font-size: 1.2rem;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/Toolbar.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBDIQ;ECHR,cAAA;EACA,mBAAA;AAUJ;AARI;EAGI,mBAAA;EACA,mBDJI;ECKJ,cDRU;ECSV,aAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;AAQR;AANQ;EACI,4BAAA;EACA,YAAA;EACA,gBAAA;AAQZ;AALQ;EACI,cDtBM;ECuBN,eAAA;EACA,gBAAA;EACA,qBAAA;AAOZ;AAJQ;EACI,iBAAA;EACA,gBAAA;AAMZ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.toolbar {\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    background: $pale-blue;\n    color: $dk-blue-toolbar;\n    padding-right: 24px;\n\n    .tb-content-wrapper {\n\n\n        align-items: center;\n        background: $pale-blue;\n        color: $dk-blue-toolbar;\n        display: flex;\n        font-size: 4rem;\n        font-weight: 900;\n        height: 80px;\n        padding: 0 12px 0 36px;\n\n        .divider {\n            border-left: 1px solid white;\n            height: 60px;\n            margin: 0px 24px;\n        }\n\n        .toolbar-link-home {\n            color: $dk-blue-toolbar;\n            font-size: 2rem;\n            font-weight: 700;\n            text-decoration: none;\n        }\n\n        span {\n            font-size: 1.2rem;\n            font-weight: 600;\n        }\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
